import { render } from "./StudentGrantsNutritionView.vue?vue&type=template&id=ce15ec54&scoped=true"
import script from "./StudentGrantsNutritionView.vue?vue&type=script&lang=js"
export * from "./StudentGrantsNutritionView.vue?vue&type=script&lang=js"

import "./StudentGrantsNutritionView.vue?vue&type=style&index=0&id=ce15ec54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce15ec54"]])

export default __exports__